import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, fromEvent, merge, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class NetworkStatusService implements OnDestroy {

  private _online$ = new BehaviorSubject<boolean>(navigator.onLine);

  /** Observable que emite true quando há conexão, false quando não há */
  online$: Observable<boolean> = this._online$.asObservable();

  private offlineEvent$: Observable<Event>;
  private onlineEvent$: Observable<Event>;

  constructor() {
    this.offlineEvent$ = fromEvent(window, 'offline');
    this.onlineEvent$ = fromEvent(window, 'online');

    merge(
      of(navigator.onLine),
      this.onlineEvent$.pipe(map(() => true)),
      this.offlineEvent$.pipe(map(() => false))
    ).subscribe((status) => this._online$.next(status));
  }

  /** Verifica ativamente se há conexão tentando uma requisição HEAD */
  async checkConnection(): Promise<boolean> {
    try {
      const response = await fetch('https://www.google.com/generate_204', {
        method: 'HEAD',
        mode: 'no-cors',
        cache: 'no-store',
      });
      this._online$.next(true);
      return true;
    } catch {
      this._online$.next(false);
      return false;
    }
  }

  ngOnDestroy(): void {
    this._online$.complete();
  }
}
